import {DELETE_METHOD, GET_METHOD, POST_METHOD, promiseCallApi} from "../../stores/tools/commons";
import {updateCustomerId} from "../../stores/slices/carts/cart";

// カタログコードから商品情報と在庫の有無を取得する
// code: カタログコード
// num: 数量
export const getItemInfos = (code, num) => {
  const query = {
    code: code,
    num: num,
  }
  const res = promiseCallApi(process.env.NEXT_PUBLIC_API_BASE_URL + "/api/v1/carts/get_item_infos", GET_METHOD, query)
  return res
}

// 特定商品をカートから取り除く
// code: カタログコード
export const removeItem = (cart_id, customer_id, code) => {
  const query = {
    cart_id: cart_id,
    customer_id: customer_id,
    code: code,
  }
  const res = promiseCallApi(process.env.NEXT_PUBLIC_API_BASE_URL + "/api/v1/carts/remove_item", DELETE_METHOD, query)
  return res
}

// 数量の変更
// code: カタログコード
// num: 数量
export const changeNum = (cart_id, customer_id, code, num) => {
  const query = {
    cart_id: cart_id,
    customer_id: customer_id,
    code: code,
    num: num
  }
  const res = promiseCallApi(process.env.NEXT_PUBLIC_API_BASE_URL + "/api/v1/carts/change_num", POST_METHOD, query)
  return res
}

//
//
export const updateCart = (id, customer_id) => {
  return (async dispatch => {
    const res = promiseCallApi(process.env.NEXT_PUBLIC_API_BASE_URL + "/api/v1/carts/update_cart", POST_METHOD, {
      id: id,
      customer_id: customer_id,
    })
    dispatch(updateCustomerId(res.data.customer_id))
  })
}